import {FactoryID, RouteKey} from "../../model-factory/type-interface/ModelFactoryType";
import {LocatePageListDataModel} from "../../data/locate/LocatePageListDataFactory";
import {getModelFactory} from "../../model-factory/ModelFactory";
import {IStringObject} from "../../common/SimpleInterface";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {LocateSearchParams} from "../../data/locate/LocateDataFactory";
import SearchBasicListRouteFactory, {SearchBasicPageListRouteModel} from "../search/SearchBasicPageListRouteFactory";

export class LocatePageListRouteModel extends SearchBasicPageListRouteModel
{

    navigationRouteKey: RouteKey = "locate_page_list_route_id";

    sourceDataModel:LocatePageListDataModel | null = null;
    searchParams:LocateSearchParams = new LocateSearchParams();

    requireSourceDataModel(): LocatePageListDataModel | null
    {
        return getModelFactory().locatePageListData.getLocatePageListDataModel(this.searchParams);
    }
}

export default class LocatePageListRouteFactory extends SearchBasicListRouteFactory
{

    id: FactoryID = "locate_page_list_route";


    getValidParamKeys(routeIDs: IRouteIDs, params: IStringObject): string[]
    {
        return super.getValidParamKeys(routeIDs, params).concat(["country", "lat", "lng", "sort_by"]);
    }

    getAdditionalRouteIDs(routeIDs: IRouteIDs, params: IStringObject, hash: string, suppliedRouteIDs?: IRouteIDs|null): IRouteIDs
    {
        const additionalIDs = super.getAdditionalRouteIDs(routeIDs, params, hash, suppliedRouteIDs);

        if(!additionalIDs.search_sort_by && params.sort_by && params.sort_by !== "name"){
            additionalIDs.search_sort_by = "distance";
        }
        if(suppliedRouteIDs?.locate_country_code){
            additionalIDs.locate_country_code = suppliedRouteIDs.locate_country_code;
        } else if(params.country){
            additionalIDs.locate_country_code = params.country.toLowerCase();
        }
        if(suppliedRouteIDs?.locate_latitude){
            additionalIDs.locate_latitude = suppliedRouteIDs.locate_latitude;
        } else if(params.lat || params.lng){
            additionalIDs.locate_latitude = parseFloat(params.lat ?? "");
        }
        if(suppliedRouteIDs?.locate_longitude){
            additionalIDs.locate_longitude = suppliedRouteIDs.locate_longitude;
        } else if(params.lat || params.lng){
            additionalIDs.locate_longitude = parseFloat(params.lng ?? "");
        }

        return additionalIDs;
    }

    birth(id: FactoryID): LocatePageListRouteModel
    {
        return new LocatePageListRouteModel(id);
    }
}